module.exports = __webpack_public_path__ + "assets/delete.0160129c.svg";